import { supabase } from "../supabase/supabase";

interface IUsedRedCards {
    game?: string;
    indicesStr?: string;
    indices?: number[];
}

export class UsedRedCards {
    game: string;
    indicesStr: string;
    indices: number[];

    constructor(game: string, indicesStr: string, indices: number[]) {
        this.game = game;
        this.indicesStr = indicesStr;
        this.indices = indices;
    }

    static getIndices(usedRedCardsIndicesStr: string)
    {
      const usedRedCardsIndices = [];
      if (usedRedCardsIndicesStr.length > 0)
      {
        usedRedCardsIndicesStr = usedRedCardsIndicesStr.substring(0, usedRedCardsIndicesStr.length - 1); // remove the last comma
      }
      const indicesList = usedRedCardsIndicesStr.length === 0 ? [] : usedRedCardsIndicesStr.split(",");
      for (let idx = 0; idx < indicesList.length; idx++)
      {
        usedRedCardsIndices.push(Number(indicesList[idx]));
      }
      return usedRedCardsIndices;
    }

    static fromJson(json: IUsedRedCards) {
        const gameId = json.game ? json.game as string : "";
        const usedRedCardsIndicesStr = json.indicesStr ? json.indicesStr as string : "";
        const usedRedCardsIndices = this.getIndices(usedRedCardsIndicesStr);
        return new UsedRedCards(
            gameId,
            usedRedCardsIndicesStr,
            usedRedCardsIndices,
        );
    }

    static async addNewUsedRedCardsRow(gameId: string) {
        const { data, error } = await supabase
            .from("UsedRedCards")
            .insert({
                game: gameId,
                indicesStr: "",
            });
    }

    static async updateUsedRedCards(gameId: string, usedRedCardsIndicesStr: string) {
        const { error } = await supabase
            .from("UsedRedCards")
            .update({ indicesStr: usedRedCardsIndicesStr })
            .eq("game", gameId);
    }

    static async getUsedRedCards(gameId: string) {
        const usedRedCards = [];
        const { data, error } = await supabase
            .from("UsedRedCards")
            .select(`
                indicesStr
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const usedRedCardsObj = this.fromJson(data![idx]);
            usedRedCards.push(usedRedCardsObj);
        }

        if (usedRedCards.length > 0) {
            return usedRedCards[0];
        }
        return new UsedRedCards("", "", []);
    }
}